exports.list = {
    path: '/consumable_equipment',
    name: 'consumable_equipment_list', 
      meta: {
        authRequired: true,
      },
    component: () => import("@/views/main/consumable_equipment/List.vue"),
}
exports.show = {
    path: '/consumable_equipment/show/:id',
    name: 'consumable_equipment_show', 
        meta: {
            authRequired: true,
        },
    component: () => import("@/views/main/consumable_equipment/Show.vue"),
}